import { Progress, Select } from "antd";
import Button from "../components/Button";
import ContentLayout from "../components/layout/ContentLayout";
import EarthChart from "../components/EarthChart";

const selectOptions = [
  {
    value: "jack",
    label: "Jack",
  },
  {
    value: "lucy",
    label: "Lucy",
  },
  {
    value: "Yiminghe",
    label: "yiminghe",
  },
  {
    value: "disabled",
    label: "Disabled",
    disabled: true,
  },
];

export default function Home() {
  const handleChange = (value) => {
    // console.log(`selected ${value}`);
  };

  return (
    <ContentLayout
      header={
        <div className="home">
          <div className="home-overview card">
            <div className="card-header">
              <h3>App Overview</h3>
              <div>
                <div className="form-row">
                  <Select
                    defaultValue="lucy"
                    style={{
                      width: 120,
                    }}
                    onChange={handleChange}
                    options={selectOptions}
                  />
                  <Button>View App Insights</Button>
                </div>
              </div>
            </div>
            <div className="home-overview-insights">
              <div className="home-overview-insight">
                <p>Downlaods</p>
                <h4 className="active">23</h4>
              </div>
              <div className="home-overview-insight">
                <p>Active Users</p>
                <h4 className="active">23</h4>
              </div>
              <div className="home-overview-insight">
                <p>Stamping</p>
                <h4 className="active">23</h4>
              </div>
              <div className="home-overview-insight">
                <p>Rewards</p>
                <h4 className="active">23</h4>
              </div>
              <div className="home-overview-insight">
                <p>Vouchers</p>
                <h4 className="active">23</h4>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <h3>Top user Accounts</h3>
              <Select
                defaultValue="lucy"
                style={{
                  width: 120,
                }}
                onChange={handleChange}
                options={selectOptions}
              />
            </div>
            <div className="table">
              <div className="table-row">
                <p className="disactive">Acount Name</p>
                <p className="disactive">Total Stamps</p>
                <p className="disactive">Total Rewards</p>
                <p className="disactive">Total Vouchers</p>
              </div>
              <div className="table-row table-data">
                <p>Acount Name</p>
                <p>Total Stamps</p>
                <p>Total Rewards</p>
                <p>Total Vouchers</p>
              </div>{" "}
              <div className="table-row table-data">
                <p>Acount Name</p>
                <p>Total Stamps</p>
                <p>Total Rewards</p>
                <p>Total Vouchers</p>
              </div>{" "}
              <div className="table-row table-data">
                <p>Acount Name</p>
                <p>Total Stamps</p>
                <p>Total Rewards</p>
                <p>Total Vouchers</p>
              </div>
            </div>
          </div>
          <div className="card">
            <h3>Users Map Location</h3>
            <div className="geo-content">
              <div className="geo-numbers">
                <div>
                  <div className="card-header">
                    <h6>Europe</h6>
                    <h6 className="disactive">580 Users</h6>
                  </div>
                  <Progress
                    percent={50}
                    showInfo={false}
                    strokeColor="#F11E69"
                  />
                </div>
                <div>
                  <div className="card-header">
                    <h6>Europe</h6>
                    <h6 className="disactive">580 Users</h6>
                  </div>
                  <Progress
                    strokeColor="#F11E69"
                    percent={60}
                    showInfo={false}
                  />
                </div>
                <div>
                  <div className="card-header">
                    <h6>Europe</h6>
                    <h6 className="disactive">580 Users</h6>
                  </div>
                  <Progress
                    strokeColor="#F11E69"
                    percent={80}
                    showInfo={false}
                  />
                </div>
                <div>
                  <div className="card-header">
                    <h6>Europe</h6>
                    <h6 className="disactive">580 Users</h6>
                  </div>
                  <Progress
                    strokeColor="#F11E69"
                    percent={30}
                    showInfo={false}
                  />
                </div>
              </div>
              <div className="geo">
                <EarthChart />
              </div>
            </div>
          </div>
        </div>
      }
    ></ContentLayout>
  );
}
